import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/de';

dayjs.extend(relativeTime);
dayjs.locale('de');
export class News {
  constructor({
    id,
    titel,
    inhalt,
    veroeffentlichtAm,
    istGelesen,
    bildUrl,
  }: {
    id: string;
    titel: string;
    inhalt: string;
    veroeffentlichtAm: string;
    istGelesen: boolean;
    bildUrl?: string;
  }) {
    this.id = id;
    this.titel = titel;
    this.inhalt = inhalt;
    this.veroeffentlichtAm = veroeffentlichtAm;
    this.istGelesen = istGelesen;
    this.bildUrl = bildUrl;
  }

  readonly id: string;
  readonly titel: string;
  readonly inhalt: string;
  readonly veroeffentlichtAm: string;
  readonly istGelesen: boolean;
  readonly bildUrl?: string;

  public veroeffentlichtAmRelative(): string {
    return dayjs(this.veroeffentlichtAm).fromNow();
  }
}
